import { SERVICE_HOST_ENV_VAR } from '../containers/constants'

export const restServices = {
  getSkus: '/product/api/skuprovider/skus/',
  programTypeProvider: '/product/api/skuprovider/program/skus/',
  createSignature: '/checkout/api/transaction/sign',
  calculateTaxes: '/checkout/api/transaction/tax/get',
  confirmPayment: '/checkout/api/transaction/confirmation/json',
  getSessionId: '/mediator/api/sessionId',
  socketConnect: '/mediator/socket',
}

export const externalServices = {
  canadaPost: {
    key: 'DB98-WX79-XM39-ZX59',
    isAutoCompleteEnabled: true,
    addressComplete:
      'https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3ex.ws',
    retrieveAddress:
      'https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/RetrieveFormatted/v2.10/json3ex.ws',
  },
  processPayment: 'https://testsecureacceptance.cybersource.com/silent/pay',
}

export const services = {}
const host =
  SERVICE_HOST_ENV_VAR in process.env
    ? process.env[SERVICE_HOST_ENV_VAR].trim()
    : 'https://client-crm-covert.dev-ocp-corp-02.ca.bestbuy.com'

Object.keys(restServices).forEach(serviceId => {
  const service = restServices[serviceId]
  services[serviceId] = `${host}${service}`
})



// WEBPACK FOOTER //
// ./src/config/services.js